import { render, staticRenderFns } from "./duplicateDialog.vue?vue&type=template&id=16ed28c0"
import script from "./duplicateDialog.vue?vue&type=script&lang=js"
export * from "./duplicateDialog.vue?vue&type=script&lang=js"
import style0 from "./duplicateDialog.vue?vue&type=style&index=0&id=16ed28c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports